import React, { useEffect } from 'react';

export default function Graph85(props) {

    let {a, b} = props.data;
        
    props.board.create('functiongraph',[function(x){return a*x + b;}],{strokeColor:'black',highlightStrokeColor:'black'});

    return <></>
}